import { useTranslation } from 'react-i18next';

import { getEvaluationDisciplineAdminSignedFileDownloadUrl } from '@/module/Evaluation/model/EvaluationApi';
import { useEvaluationUploadDisciplineAdminSignedFile } from '@/module/Evaluation/model/EvaluationQuery';

import { Id, PersistentFile, useAppNotification } from '@feature/utils';

import { EvaluationAuthorFile } from './EvaluationAuthorFile';

interface EvaluationDisciplineAdminSignedFileProps {
  userId: Id;
  evaluationId: Id;
  file: PersistentFile | null;

  disabled: boolean;
}

export function EvaluationDisciplineAdminSignedFile({
  evaluationId,
  userId,
  file,
  disabled,
}: EvaluationDisciplineAdminSignedFileProps) {
  const { mutate, isPending } = useEvaluationUploadDisciplineAdminSignedFile(evaluationId, userId);
  const notification = useAppNotification();
  const { t } = useTranslation();

  const onUpload = (newFile: File) => {
    mutate(newFile, {
      onSuccess: notification.success,
      onError: notification.error,
    });
  };

  return (
    <EvaluationAuthorFile
      onUpload={onUpload}
      file={file}
      disabled={disabled}
      onDownload={() => window.open(getEvaluationDisciplineAdminSignedFileDownloadUrl(evaluationId, userId))}
      isSubmitting={isPending}
      label={t('evaluation.files.disciplineAdminSigned.label')}
      description={t('evaluation.files.disciplineAdminSigned.description')}
      accept="application/pdf"
    />
  );
}
